import React, { useState } from "react";
import { useParams } from "react-router-dom";
import emailjs from "@emailjs/browser";
import "./ProductDetails.css";

import Racket1 from "../assets/Racket1.jpg";
import Racket2 from "../assets/Racket2.webp";
import Racket3 from "../assets/Racket3.webp";
import Racket4 from "../assets/Racket4.webp";

const products: any = {
  finapi232: {
    name: "Apacs Finapi 232",
    price: "$95",
    desc: "High-performance racket designed for powerful smashes.",
    image: Racket1,
    link: "https://buy.stripe.com/28EdRbgJf4ftc7faWWejK00",
  },
  counterattack: {
    name: "Apacs Counter Attack",
    price: "$85",
    desc: "Great for speed and quick reactions.",
    image: Racket2,
    link: "https://buy.stripe.com/14A14p64B9zN0oxe98ejK02",
  },
  zziggler: {
    name: "Apacs Z-Ziggler",
    price: "$90",
    desc: "Durable and high tension capacity.",
    image: Racket3,
    link: "https://buy.stripe.com/7sY5kFdx3dQ38V35CCejK03",
  },
  asgardia: {
    name: "Apacs Asgardia Lite",
    price: "$80",
    desc: "Lightweight for speed and agility.",
    image: Racket4,
    link: "https://buy.stripe.com/bJe00l0KhdQ32wF5CCejK01",
  },
};

const ProductDetails = () => {
  const { id } = useParams();
  const product = products[id as keyof typeof products];

  const [showForm, setShowForm] = useState(false);

  if (!product) return <h2>Product not found</h2>;

  // SEND EMAIL
  const sendEmail = (e: any) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_7wg915y", // 🔴 replace
        "template_r41z0u8", // 🔴 replace
        e.target,
        "TmSR43pdEXcy8M__z", // 🔴 replace
      )
      .then(() => {
        alert("Details submitted!");
        window.open(product.link, "_blank"); // go to Stripe
      })
      .catch(() => alert("Error sending email"));
  };

  return (
    <div className="product-page">
      <div className="product-container">
        {/* IMAGE */}
        <div className="product-image">
          <img src={product.image} alt={product.name} />
        </div>

        {/* INFO */}
        <div className="product-info">
          <h1>{product.name}</h1>
          <p>{product.desc}</p>

          <button className="buy-btn" onClick={() => setShowForm(true)}>
            BUY NOW – {product.price}
          </button>
        </div>
      </div>

      {/* POPUP FORM */}
      {showForm && (
        <div className="popup">
          <div className="popup-content">
            <h2>Delivery Details</h2>

            <form onSubmit={sendEmail}>
              <input name="name" placeholder="Full Name" required />
              <input name="email" placeholder="Email" required />
              <input name="phone" placeholder="Phone Number" required />
              <textarea name="address" placeholder="Full Address" required />

              <input type="hidden" name="product" value={product.name} />

              <button type="submit">Proceed to Payment</button>
              <button type="button" onClick={() => setShowForm(false)}>
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetails;
